import { useMutation } from "@tanstack/react-query";
import { api } from "./api";
import { clerkClient } from "@/App";

const BASE_URL = "/payments";

export interface CreateCheckoutSessionResponse {
  url: string;
  sessionId?: string;
}

export interface CreateCheckoutSessionInput {
  priceId?: string;
  successUrl?: string;
  cancelUrl?: string;
  product?: string;
  [key: string]: unknown;
}

export interface CreateCustomerPortalSessionResponse {
  url: string;
}

export const useCreateCheckoutSessionMutation = () => {
  return useMutation({
    mutationFn: async (data?: CreateCheckoutSessionInput) => {
      const authToken = await clerkClient.session?.getToken();
      if (!authToken) {
        throw new Error("Authentication required");
      }
      const response = await api.post<CreateCheckoutSessionResponse>(
        `${BASE_URL}/create-checkout-session`,
        data || {},
        {
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );
      return response.data;
    },
    onSuccess: (data) => {
      if (data.url) {
        window.location.href = data.url;
      } else {
        throw new Error("Checkout URL not provided by server");
      }
    },
  });
};

export const useCreateCustomerPortalSessionMutation = () => {
  return useMutation({
    mutationFn: async () => {
      const authToken = await clerkClient.session?.getToken();
      if (!authToken) {
        throw new Error("Authentication required");
      }
      const response = await api.post<CreateCustomerPortalSessionResponse>(
        `${BASE_URL}/customer-portal`,
        {},
        {
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );
      return response.data;
    },
    onSuccess: (data) => {
      if (data.url) {
        window.location.href = data.url;
      } else {
        throw new Error("Customer portal URL not provided by server");
      }
    },
  });
};